import { render, staticRenderFns } from "./Eventlist.vue?vue&type=template&id=3503b66e&scoped=true"
import script from "./Eventlist.vue?vue&type=script&lang=js"
export * from "./Eventlist.vue?vue&type=script&lang=js"
import style0 from "./Eventlist.vue?vue&type=style&index=0&id=3503b66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503b66e",
  null
  
)

export default component.exports